/**
 * Per-tool presentation for the confirmation card.
 *
 * The card renders the stored tool arguments verbatim, because they are what the resume
 * replays. Everything here is decoration on top of that: a friendlier name for an argument,
 * or a whole renderer for a capability that can say more than a key/value list (a write
 * tool showing a before/after diff, say). Nothing here can hide an argument - an entry that
 * goes stale against a renamed argument loses its label and falls back to the raw key, which
 * is why the card shows the key alongside the label rather than instead of it.
 */

/**
 * Tool name -> argument key -> the name to show a user. Add an entry only where the internal
 * name is genuinely unhelpful; the raw key is the default and is never wrong.
 */
export const ARGUMENT_LABELS = {};

/**
 * Tool name -> a component taking `{ input, translate }`. Registering one replaces the whole
 * argument list for that tool.
 */
export const CONFIRMATION_RENDERERS = {};

export const getArgumentLabel = (toolName, argumentKey) => ARGUMENT_LABELS[toolName]?.[argumentKey] ?? null;

export const getConfirmationRenderer = toolName => CONFIRMATION_RENDERERS[toolName] ?? null;
